import ShopPage from './ShopPage';

export default ShopPage;
export { getServerSideProps } from './serverSideProps';
